import { useState } from 'react';

import { Col, Form, Radio, Row, Typography } from 'antd';

import INTERNAL_LINKS from '../../enums/InternalLinks';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import { catchException } from '../../utils/helpers/helpers';
import {
  getAnnouncements,
  getReport,
  getYears,
} from '../../api/module/announcement_reports';
import CustomSelector from '../../components/CustomSelector';
import { CustomButton } from '../../components';

import { Link } from 'react-router-dom';

const { Title } = Typography;

const breadcrumbItems = [
  {
    text: 'Convocatoria',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
  },
  {
    text: 'Reportes Convocatorias',
  },
];

export default function AnnouncementReports() {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  async function onFinish(values) {
    try {
      setLoading(true);
      await getReport(values.report_name, values.announcements);
      form.setFieldValue('report_name', undefined);
      setLoading(false);
    } catch (err) {
      catchException(err);
      setLoading(false);
    }
  }

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Reportes Convocatorias
      </Title>
      <Form
        form={form}
        onFinish={onFinish}
        onValuesChange={(cv, v) => {
          if (cv.hasOwnProperty('year')) {
            form.setFieldsValue({
              announcements: undefined,
              report_name: undefined,
            });
          }
          if (cv.hasOwnProperty('announcements')) {
            form.setFieldsValue({
              report_name: undefined,
            });
          }
        }}
        layout="vertical"
      >
        <Row gutter={10}>
          <Col flex={'15em'}>
            <Form.Item
              name="year"
              label="1. Seleccione el año"
              rules={[{ required: true }]}
            >
              <CustomSelector
                endpointFetch={getYears}
                selectorProps={{ placeholder: 'Año' }}
              />
            </Form.Item>
          </Col>
          <Col flex={'auto'}>
            <Form.Item noStyle dependencies={['year']}>
              {({ getFieldValue }) => {
                const y = getFieldValue('year');
                if (!y) return null;
                return (
                  <Form.Item
                    name="announcements"
                    label="2. Digite el número de convocatoria o nombre de la convocatoria (puede seleccionar más de una convocatoria)"
                    rules={[{ required: true }]}
                  >
                    <CustomSelector
                      endpointFetch={async () => {
                        return await getAnnouncements(y);
                      }}
                      mode="multiple"
                      selectorProps={{
                        placeholder: 'Convocatorias',
                        width: '100%',
                      }}
                      selectorKey={y}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item noStyle dependencies={['announcements']}>
          {({ getFieldValue }) => {
            const an = getFieldValue('announcements');
            if (!an) return null;
            return (
              <Form.Item
                name="report_name"
                label="3. Seleccione los reportes que requiera"
                rules={[{ required: true }]}
              >
                <Radio.Group
                  style={{
                    width: '100%',
                  }}
                  buttonStyle="solid"
                >
                  <Radio.Button value={'identification_data'}>
                    1. Datos de identificación
                  </Radio.Button>
                  <Radio.Button value={'education_data'}>
                    2. Formación
                  </Radio.Button>
                  <Radio.Button value={'experience_data'}>
                    3. Experiencia
                  </Radio.Button>
                  <Radio.Button value={'icfes_experience_data'}>
                    4.1 Experiencia ICFES
                  </Radio.Button>
                  <Radio.Button value={'certifications_data'}>
                    4.2 Otras certificaciones
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item>
          <CustomButton
            type="default"
            text="Descargar Excel"
            loading={loading}
            disabled={loading}
          />
        </Form.Item>
      </Form>
      <CustomButton
        htmlType="button"
        className={'back-button'}
        type="default"
        text={<Link to={`${INTERNAL_LINKS.ANNOUNCEMENT}`}>Volver</Link>}
      />
    </>
  );
}
